import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/types/content";

interface MovieGridProps {
  movies: Movie[];
  className?: string;
}

export default function MovieGrid({ movies, className = "" }: MovieGridProps) {
  return (
    <div
      className={`grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 ${className}`}
    >
      {movies.map((movie, index) => (
        <MovieCard key={movie.id} movie={movie} index={index} />
      ))}
    </div>
  );
}